var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  A top level library for Bitcoin Cash (BCH) handling. This library will
  encapsulate a lot of support libraries and contain BCH-specific methods.
*/
var BchAdapter = /*#__PURE__*/function () {
  "use strict";

  function BchAdapter(bchConfig) {
    _classCallCheck(this, BchAdapter);

    // Input Validation
    if (!bchConfig.bchjs) {
      throw new Error('An instance of bch-js must be passed when instantiating the BCH adapter library.');
    }

    this.bchjs = bchConfig.bchjs;
    this.mnemonic = bchConfig.mnemonic;
  } // Generate a BCH key pair and address. Returns an object with this information,
  // which can be used for payments and e2e encryption.
  // 12-word mnemonic string input is optional. Will generate a new wallet and
  // keypair if not provided. Will use the first address on the SLIP44
  // derivation path of 245 if a 12 word mnemonic is provided.


  _createClass(BchAdapter, [{
    key: "generateBchId",
    value: function () {
      var _generateBchId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var rootSeed, masterHDNode, childNode, outObj, pubKey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                // Generate a 12-word mnemonic, if one isn't provided.
                if (!this.mnemonic) {
                  this.mnemonic = this.bchjs.Mnemonic.generate(128, this.bchjs.Mnemonic.wordLists().english);
                } // console.log(`mnemonic: ${mnemonic}`)
                // root seed buffer


                _context.next = 4;
                return this.bchjs.Mnemonic.toSeed(this.mnemonic);

              case 4:
                rootSeed = _context.sent;
                masterHDNode = this.bchjs.HDNode.fromSeed(rootSeed);
                childNode = masterHDNode.derivePath("m/44'/245'/0'/0/0");
                outObj = {}; // Generate the cash and SLP addresses.

                outObj.cashAddress = this.bchjs.HDNode.toCashAddress(childNode);
                outObj.slpAddress = this.bchjs.SLP.Address.toSLPAddress(outObj.cashAddress); // No need to export the private key?
                // outObj.WIF = this.bchjs.HDNode.toWIF(childNode)
                // Export the public key as a hex string. This will be used for e2e
                // encryption.

                pubKey = this.bchjs.HDNode.toPublicKey(childNode);
                outObj.publicKey = pubKey.toString('hex');
                return _context.abrupt("return", outObj);

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                console.error('Error in bch-lib.js/generateBchId()');
                throw _context.t0;

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 15]]);
      }));

      function generateBchId() {
        return _generateBchId.apply(this, arguments);
      }

      return generateBchId;
    }()
  }, {
    key: "generatePrivateKey",
    value: function () {
      var _generatePrivateKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var rootSeed, masterHDNode, childNode, privKey;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                // Generate a 12-word mnemonic, if one isn't provided.
                if (!this.mnemonic) {
                  this.mnemonic = this.bchjs.Mnemonic.generate(128, this.bchjs.Mnemonic.wordLists().english);
                } // console.log(`mnemonic: ${mnemonic}`)
                // root seed buffer


                _context2.next = 4;
                return this.bchjs.Mnemonic.toSeed(this.mnemonic);

              case 4:
                rootSeed = _context2.sent;
                masterHDNode = this.bchjs.HDNode.fromSeed(rootSeed);
                childNode = masterHDNode.derivePath("m/44'/245'/0'/0/0");
                privKey = this.bchjs.HDNode.toWIF(childNode);
                return _context2.abrupt("return", privKey);

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);
                console.error('Error in bch-lib.js/generatePrivateKey()');
                throw _context2.t0;

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 11]]);
      }));

      function generatePrivateKey() {
        return _generatePrivateKey.apply(this, arguments);
      }

      return generatePrivateKey;
    }()
  }]);

  return BchAdapter;
}();

module.exports = BchAdapter;